import type { IconData } from '@stacksjs/iconify-core'

export const shoppingStore: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M3 0h10l3 3v.333a2.667 2.667 0 0 1-5.333 0a2.667 2.667 0 0 1-5.334 0a2.667 2.667 0 1 1-5.333 0V3z\"/><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1 16V7.5h14V16h-3v-5.5H9V16zm4-3.5A1.25 1.25 0 1 0 5 10a1.25 1.25 0 0 0 0 2.5\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default shoppingStore
